import { render, staticRenderFns } from "./SubmitFormItemSection.vue?vue&type=template&id=121f5c86&scoped=true"
import script from "./SubmitFormItemSection.vue?vue&type=script&lang=js"
export * from "./SubmitFormItemSection.vue?vue&type=script&lang=js"
import style0 from "./SubmitFormItemSection.vue?vue&type=style&index=0&id=121f5c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121f5c86",
  null
  
)

export default component.exports